import * as v from "valibot";

export const uuidSchema = v.pipe(v.string(), v.uuid(), v.brand("UUID"));

export type UUID = v.InferOutput<typeof uuidSchema>;

export function isValidUuid(input: unknown): input is UUID {
  return v.is(uuidSchema, input);
}
